var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-box container"},[_c('el-card',{staticClass:"box1"},[_c('h1',{staticClass:"title"},[_vm._v("关于本站")]),_c('div',{ref:"preview",staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.$store.state.webSiteInfo.aboutMe)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }